import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-204882fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-bar" }
const _hoisted_2 = { class: "main-bar__numbers" }
const _hoisted_3 = { class: "main-bar__icon" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "main-bar__threshold main-bar__threshold--high" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "main-bar__threshold main-bar__threshold--medium" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "main-bar__threshold main-bar__threshold--light" }, null, -1))
const _hoisted_7 = [
  _hoisted_4,
  _hoisted_5,
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PotionIcon = _resolveComponent("PotionIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, [
        _createVNode(_component_PotionIcon)
      ]),
      _createElementVNode("h6", null, _toDisplayString(_ctx.intoxication.current) + " /", 1)
    ]),
    _createElementVNode("div", {
      style: _normalizeStyle(_ctx.gradient),
      class: "main-bar__bar"
    }, _hoisted_7, 4)
  ]))
}